module.exports = __webpack_public_path__ + "assets/media/morning.c87ff4a9.mp3";